
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const GeneralEnglishPage = lazy(() => import('../pages/services/general-english/page'));
const BusinessEnglishPage = lazy(() => import('../pages/services/business-english/page'));
const TestPrepPage = lazy(() => import('../pages/services/test-prep/page'));
const InterpretationTranslationPage = lazy(() => import('../pages/services/interpretation-translation/page'));
const CorporateTrainingPage = lazy(() => import('../pages/services/corporate-training/page'));
const MultilingualPage = lazy(() => import('../pages/services/multilingual/page'));
const NWSystemPage = lazy(() => import('../pages/nw-system/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const NoticeDetailPage = lazy(() => import('../pages/support/notice/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/services',
    element: <ServicesPage />
  },
  {
    path: '/services/general-english',
    element: <GeneralEnglishPage />
  },
  {
    path: '/services/business-english',
    element: <BusinessEnglishPage />
  },
  {
    path: '/services/test-prep',
    element: <TestPrepPage />
  },
  {
    path: '/services/interpretation-translation',
    element: <InterpretationTranslationPage />
  },
  {
    path: '/services/corporate-training',
    element: <CorporateTrainingPage />
  },
  {
    path: '/services/multilingual',
    element: <MultilingualPage />
  },
  {
    path: '/nw-system',
    element: <NWSystemPage />
  },
  {
    path: '/support',
    element: <SupportPage />
  },
  {
    path: '/support/notice/:id',
    element: <NoticeDetailPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/admin',
    element: <AdminPage />
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
